




















































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { companyServer, institutionServer, schedulePlan } from '@/api/installServer';
import dayjs from 'dayjs';
import PlanEdit from './plan-edit.vue';
import { arrayToTree } from '@/util/arrayToTree';

const CALENDAR_MAP: any = { work: '4', rest: '3' };
@Component({
  components: { PlanEdit },
})
export default class InstitutionEdit extends Vue {
  @Prop(Number) editOrganFlag!: number; // 控制编辑还是新增机构
  @Prop(String) rowId!: string; // 父组件传递过来的 rowId
  @Prop(String) type!: any; // 父组件传递过来一行的 type 类型
  private WEEK: any = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'];
  private defaultTime: any = new Date('2019-08-06 00:00:00');
  private planList: any = [];
  private clonePlanList: any = [];
  private planDetail: any = {
    spaceId: '',
    startTime: '',
    endTime: '',
    isHoliday: false,
    scheduleCalendar: [],
    startScheduleDate: '',
    restRuleType: '',
    restRuleInfo: [],
    companyId: '',
    companyName: '',
  };
  private index: any = '';
  private planStaffIdList: any = [];
  private planChecked: any = '';
  private planCalendar: any = [];
  private tempCalendar: any = [];
  private tempRule: any = [];
  private firstDay: any = 0;
  private month: any = dayjs().format('YYYY-MM');
  private checkedDate: any = '';
  private checkedIndex: any = '';
  private checkRule: any = '';
  private searchValue: any = '';
  private loading: any = false;
  private planRules: any = {
    name: [{ required: true, message: '请输入排班名称', trigger: 'blur' }],
    startTime: [{ required: true, message: '请选择开始时间', trigger: 'blur' }],
    endTime: [{ required: true, message: '请选择结束时间', trigger: 'blur' }],
    spaceId: [{ required: true, message: '请选择单位', trigger: 'blur' }],
  };
  private saveDisabled: any = false;
  private companyData: any = [];
  private companyDataArr: any = [];
  private enterpriseData: any = [];
  private addButton: any;

  async created() {
    this.getCompanyDataList();
    this.getEnterpriseDataList();
  }

  async mounted() {
    if (this.type === 'edit') {
      this.handleShowPlanClick(this.rowId);
    } else {
      this.handleAddPlanBtnClick();
    }
    await this.getCalendar(this.month);
    this.addButton = document.getElementById('addButton');
  }

  /**
   *【按钮】新建排班方案按钮点击
   * @Params
   * @return
   **/
  handleAddPlanBtnClick() {
    this.planDetail = {
      spaceId: '',
      id: '',
      name: '',
      describe: '',
      restRuleType: 'without',
      restRuleInfo: [],
      isHoliday: false,
      startTime: '',
      endTime: '',
      scheduleOrderInfo: [],
      startScheduleDate: '',
      scheduleCalendar: [],
      companyId: '',
      companyName: '',
    };
  }

  /**
   * 【按钮】排班方案编辑按钮点击获取详情
   * @Params
   * @return
   **/
  handleShowPlanClick(id: string) {
    this.loading = true;
    if (id.length > 5) {
      this.getPlanData(id);
      this.type = 'edit';
    } else {
      this.type = 'add';
      this.loading = false;
    }
  }

  /**
   *【按钮】清空休息规则
   * @Params
   * @return
   **/
  handleChangeRestRule() {
    this.planDetail.restRuleInfo = [];
  }

  /**
   *【日历】点击改变所选日期
   * @Params
   * @return
   **/
  handleChangePlan(index: any) {
    this.checkedDate = this.planCalendar[index].date;
    this.checkRule = '';
    this.checkedIndex = index;
  }

  /**
   *【按钮】改变日历月份
   * @Params
   * @return
   **/
  async handleChangeMonth() {
    await this.getCalendar(this.month);
    await this.changeCalendar('update');
  }

  /**
   * 【接口】获取企业列表
   */
  private getEnterpriseDataList() {
    companyServer
      .getCompanySelectList({
        companyPlaceType: 'COMPANY',
      })
      .then((res: any) => {
        this.enterpriseData = res.data;
      });
  }
  companyChange(e: any) {
    this.planDetail.companyName = '';
    if (e) {
      this.planDetail.companyName = this.enterpriseData.find((item: any) => item.id === e).companyName;
    }
  }

  /**
   * 【接口】获取单位列表
   */
  private getCompanyDataList() {
    institutionServer
      .getCompanyList({})
      .then((res: any) => {
        if (res.code === '200') {
          const data: any = res.data;
          this.companyDataArr = res.data;
          this.companyData = arrayToTree(data);
          console.log(this.companyData);
        } else {
          this.$message.warning('获取数据失败，请稍后重试！');
        }
      })
      .catch((error: any) => {
        this.$message.warning('获取数据失败，请稍后重试！');
      });
  }

  spaceIdChecked(val: any) {
    if (val) {
      if (val.length > 1) {
        this.planDetail.spaceId = val[val.length - 1];
      } else if (val.length === 1) {
        this.planDetail.spaceId = val[0];
      } else {
        this.planDetail.spaceId = '';
      }
    }
    const active = val.toString();
    if (!active) {
      this.addButton.classList.add('active');
    } else {
      this.addButton.classList.remove('active');
    }
  }

  /**
   *【接口】获取日历列表
   * @Params
   * @return
   **/
  async getCalendar(date: string) {
    this.tempRule = [];
    const res: any = await schedulePlan.getCalendar(date);
    if (res.code === '200') {
      this.planCalendar = res.data;
      this.tempCalendar = [];
      res.data.forEach((item: any) => {
        this.tempRule.push('');
        this.tempCalendar.push({
          name: item.name,
          type: item.type,
          label: item.label,
          date: item.date,
        });
      });
    }
    const temp = new Date(this.planCalendar[0].date);
    if (temp.getDay() === 0) {
      this.firstDay = 21;
    } else {
      this.firstDay = temp.getDay() * 3;
    }
  }
  /**
   *【日历】改变日历上显示的休班规则
   * @Params
   * @return
   **/
  changeCalendar(type: string) {
    if (type === 'update') {
      this.planCalendar.forEach((item: any, index: any) => {
        this.planDetail.scheduleCalendar.forEach((ctx: any) => {
          if (ctx.date === item.date) {
            if (ctx.type === 'rest') {
              item.type = CALENDAR_MAP.rest;
            } else {
              item.type = CALENDAR_MAP.work;
            }
          }
        });
      });
    } else {
      this.planCalendar.forEach((item: any, index: any) => {
        item.type = this.tempCalendar[index].type;
        this.planDetail.scheduleCalendar.forEach((ctx: any) => {
          if (ctx.date === item.date) {
            if (ctx.type === 'rest') {
              item.type = CALENDAR_MAP.rest;
            } else {
              item.type = CALENDAR_MAP.work;
            }
          }
        });
      });
    }
  }

  /**
   * 【按钮】新增按钮点击
   * @Params
   * @return
   **/
  handleAddStaffBtnClick() {
    const StaffComponent: any = this.$refs['staffEdit'];
    StaffComponent.showDialog(-1, []);
  }

  /**
   * 【按钮】清空按钮点击
   * @Params
   * @return
   **/
  handleClearStaffBtnClick() {
    this.planDetail.scheduleOrderInfo = [];
  }

  /**
   *【排班方案编辑窗口】排班方案编辑窗口提交请求成功
   * @Params
   * @return
   **/
  handleStaffEditResponse(res: any) {
    if (res.index < 0) {
      if (res.staff.length > 0) {
        this.planDetail.scheduleOrderInfo.push({
          staffList: res.staff,
        });
      }
    } else {
      this.planDetail.scheduleOrderInfo[res.index].staffList = res.staff;
    }
  }

  /**
   * 【按钮】排版顺序编辑按钮点击
   * @Params
   * @return
   **/
  handleEditBtnClick(num: any) {
    const StaffComponent: any = this.$refs['staffEdit'];
    this.planStaffIdList = [];
    this.planDetail.scheduleOrderInfo[num].staffList.forEach((item: any) => {
      this.planStaffIdList.push(item);
    });
    StaffComponent.showDialog(num, this.planStaffIdList);
  }

  /**
   * 【按钮】排版顺序删除按钮点击
   * @Params
   * @return
   **/
  handleDeleteBtnClick(num: any) {
    this.planDetail.scheduleOrderInfo.splice(num, 1);
  }

  /**
   * 【按钮】排版顺序上移按钮点击
   * @Params
   * @return
   **/
  handleUpBtnClick(num: any) {
    const temp = this.planDetail.scheduleOrderInfo[num];

    if (num !== 0) {
      this.planDetail.scheduleOrderInfo.splice(num, 1);
      this.planDetail.scheduleOrderInfo.splice(num - 1, 0, temp);
      const temp_date: any = this.planDetail.scheduleOrderInfo[num - 1].scheduleDate;
      this.planDetail.scheduleOrderInfo[num - 1].scheduleDate = this.planDetail.scheduleOrderInfo[num].scheduleDate;
      this.planDetail.scheduleOrderInfo[num].scheduleDate = temp_date;
    }
  }

  /**
   * 【按钮】排版顺序下移按钮点击
   * @Params
   * @return
   **/
  handleDownBtnClick(num: any) {
    const temp = this.planDetail.scheduleOrderInfo[num];
    if (num !== this.planDetail.scheduleOrderInfo.length) {
      this.planDetail.scheduleOrderInfo.splice(num, 1);
      this.planDetail.scheduleOrderInfo.splice(num + 1, 0, temp);
      const temp_date: any = this.planDetail.scheduleOrderInfo[num].scheduleDate;
      this.planDetail.scheduleOrderInfo[num].scheduleDate = this.planDetail.scheduleOrderInfo[num + 1].scheduleDate;
      this.planDetail.scheduleOrderInfo[num + 1].scheduleDate = temp_date;
    }
  }

  /**
   *【接口】获取排班方案详情
   * @Params
   * @return
   **/
  async getPlanData(id: string) {
    const res: any = await schedulePlan.get(id);
    if (res.code === '200') {
      setTimeout(() => {
        const flag: any = res.data.holiday;
        this.planDetail = res.data;
        this.planDetail.isHoliday = flag;
        this.changeCalendar('update');
        this.loading = false;
      }, 1000);
    }
  }

  /**
   *【接口】排班方案添加
   * @Params
   * @return
   **/
  async addPlanData() {
    try {
      const tempInfo: any = [];
      this.planDetail.scheduleOrderInfo.forEach((item: any) => {
        const staffIds: any = [];
        item.staffList.forEach((ctx: any) => {
          staffIds.push(ctx.id);
        });
        tempInfo.push({
          staffIds: staffIds,
        });
      });
      const res: any = await schedulePlan.add({
        name: this.planDetail.name,
        describe: '',
        spaceId: this.planDetail.spaceId,
        restRuleType: this.planDetail.restRuleType,
        restRuleInfo: this.planDetail.restRuleInfo,
        isHoliday: this.planDetail.isHoliday,
        startTime: this.planDetail.startTime,
        endTime: this.planDetail.endTime,
        scheduleOrderInfo: tempInfo,
        startScheduleDate: this.planDetail.startScheduleDate,
        scheduleCalendar: this.planDetail.scheduleCalendar,
        companyId: this.planDetail.companyId,
        companyName: this.planDetail.companyName,
      });
      if (res.code === '200') {
        this.$message.success('您成功保存了记录。');
        this.$emit('update:show', true); // 返回主页
        this.saveDisabled = false;
      } else {
        this.$message.warning('保存失败');
        this.saveDisabled = false;
        throw new Error();
      }
    } catch (e) {
      this.saveDisabled = false;
      throw new Error();
    }
  }

  /**
   *【接口】获取排班方案修改
   * @Params
   * @return
   **/
  async editPlanData(id: string) {
    const tempInfo: any = [];
    this.planDetail.scheduleOrderInfo.forEach((item: any) => {
      const staffIds: any = [];
      item.staffList.forEach((ctx: any) => {
        staffIds.push(ctx.id);
      });
      if (item.id) {
        tempInfo.push({
          id: item.id,
          staffIds: staffIds,
        });
      } else {
        tempInfo.push({
          staffIds: staffIds,
        });
      }
    });
    const res: any = await schedulePlan.edit(id, {
      name: this.planDetail.name,
      describe: '',
      spaceId: this.planDetail.spaceId,
      restRuleType: this.planDetail.restRuleType,
      restRuleInfo: this.planDetail.restRuleInfo,
      isHoliday: this.planDetail.isHoliday,
      startTime: this.planDetail.startTime,
      endTime: this.planDetail.endTime,
      scheduleOrderInfo: tempInfo,
      startScheduleDate: this.planDetail.startScheduleDate,
      scheduleCalendar: this.planDetail.scheduleCalendar,
      companyId: this.planDetail.companyId,
      companyName: this.planDetail.companyName,
    });
    if (res.code === '200') {
      this.$message.success('您成功保存了记录。');
      this.$emit('update:show', true); // 返回主页
      this.saveDisabled = false;
    } else {
      this.$message.warning('保存失败');
      this.saveDisabled = false;
      throw new Error();
    }
  }

  /**
   *【按钮】休班规则按钮
   * @Params
   * @return
   **/
  handleChangeRule(rule: string) {
    if (rule !== 'cancel') {
      let flag = true;
      this.planDetail.scheduleCalendar.forEach((item: any) => {
        if (item.date === this.checkedDate) {
          item.type = rule;
          flag = false;
        }
      });
      if (flag === true) {
        this.planDetail.scheduleCalendar.push({
          date: this.checkedDate,
          type: rule,
        });
      }
      this.changeCalendar('update');
    } else {
      this.planDetail.scheduleCalendar.forEach((item: any, index: any) => {
        if (item.date === this.checkedDate) {
          this.planDetail.scheduleCalendar.splice(index, 1);
          this.changeCalendar('restore');
        }
      });
    }
  }

  /**
   *【按钮】提交按钮点击
   * @Params
   * @return
   **/
  handleSubmitBtnClick() {
    this.loading = true;
    this.saveDisabled = true;
    const formComponent: any = this.$refs['planDetail'];
    formComponent.validate((valid: any) => {
      if (!valid) {
        this.saveDisabled = false;
        return;
      }
      switch (this.type) {
        case 'add':
          this.addPlanData();
          break;
        case 'edit':
          this.editPlanData(this.rowId);
          break;
      }
    });
    this.loading = false;
  }

  /**
   * @desc 返回上一个页面
   * @param1 暂无
   * @returns 暂无
   */
  close() {
    const formComponent: any = this.$refs['planDetail'];
    formComponent.clearValidate();
    this.$emit('update:show', true); // 返回主页
  }

  changeHoliday(val: any) {
    this.$set(this.planDetail, 'isHoliday', val);
    this.$forceUpdate();
  }
}
